import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-112">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-id="element-113">
          <div className="max-w-2xl mx-auto px-3 sm:px-4 py-2.5 sm:py-3 flex items-center justify-between gap-2 sm:gap-3" data-id="element-114">
            <div className="flex flex-col leading-tight min-w-0" data-id="element-115">
              <span className="text-[9px] sm:text-xs font-bold uppercase tracking-wider text-brand-swiss-red" data-id="element-116">
                SPS PRO 2026 🇨🇭
              </span>
              <span className="text-[13px] sm:text-base font-bold text-brand-charcoal truncate" data-id="element-117">
                Ab CHF 19.90 · Einmalzahlung
              </span>
            </div>
            <div className="flex-1 max-w-[55%] sm:max-w-[260px]" data-id="element-118">
              <CTAButton className="py-2.5 sm:py-3 text-[13px] sm:text-base" data-id="element-119">
                JETZT KAUFEN
              </CTAButton>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}